import { ClaimType } from '@constants';
import { useSelector } from 'react-redux';
import { CheckPage } from '../check';
import { Delay } from '../delay';
import { CheckRA } from '../check-RA';
import { Theft } from '../d_theft';
import { RadioRA } from '../radio-RA';

const ChoosePageMap = {
  [ClaimType.Theft]: <Theft />,
  [ClaimType.Delay]: <Delay />,
  [ClaimType.Damage]: <CheckPage />,
  [ClaimType.Loss]: <CheckPage />,
  [ClaimType.RA]: <CheckRA />,
  [ClaimType.EW]: <RadioRA />,
  [ClaimType.AD]: <RadioRA />,
};

export const ChoosePage = () => {
  const { type } = useSelector((state) => state.claim);
  return ChoosePageMap[type];
};
